export class AddVendorRequest {
    
    DisplayName: string;
    Email: string;
    FirstName: string;
    LastName: string;
    IsActive: string;

}
